﻿import React from 'react';
import InfoCardLoader from "../../deprecatedUikit/InfoCard/InfoCardLoader";

/**
 * Skeleton loader for SupplierActivitySummaryCardList
 * @constructor
 */
const SupplierActivitySummaryCardListLoader = () => Array.from({ length: 10 }).map((_, index) => (
  <InfoCardLoader key={index} />
));

export { SupplierActivitySummaryCardListLoader };
